/**
 * @typedef { "_blank" | "_parent" | "_self" | "_top" } TTargetLink
 */

/**
 * @typedef { target: TTargetLink, download: null | string } TOptionsLink
 */

/**
 * Utility to open links using shadow anchor link
 * @param {string} src
 * @param {TOptionsLink} options
 */
export function openLink(src, options) {
  const defaultOptions = { target: "_blank", download: null };
  const validOptions = Object.assign(defaultOptions, options);
  const anchorLink = document.createElement("a");

  try {
    anchorLink.setAttribute("href", src);
    anchorLink.setAttribute("target", validOptions.target);

    if (typeof validOptions.download === "string") {
      anchorLink.setAttribute("download", validOptions.download);
    }

    document.body.appendChild(anchorLink);
    anchorLink.click();
  } catch (error) {
    window.open(src, validOptions.target);
  } finally {
    anchorLink.remove();
  }
}

/**
 * Utility to download file using shadow anchor link
 * @param { string } src
 * @param { TTargetLink } target
 */
export function downloadFile(src, target = "_blank") {
  try {
    openLink(src, { download: "download", target });
  } catch (error) {
    useToast("error", "Download indisponível");
  }
}
